import PropTypes from 'prop-types';

import { THEMATIQUE_TYPES } from './ThematiqueTypes.js';
import Modal from './utils/Modal.js';
import Icon from './utils/Icon.js';

const AddBlocModal = ({ open, onSelect, onClose }) => {
  const onThematiqueSelected = (thematique) => () => {
    onSelect(thematique.id);
  };

  return (
    <Modal
      titre="Sélectionnez une thématique"
      className="add-bloc-modal"
      open={open}
      onClose={onClose}
    >
      <div className="add-bloc-modal-thematiques">
        {THEMATIQUE_TYPES.map((thematiqueType) => (
          <button
            type="button"
            className="add-bloc-modal-thematique-btn"
            onClick={onThematiqueSelected(thematiqueType)}
            key={thematiqueType.id}
          >
            <Icon
              name={thematiqueType.icon}
              className="add-bloc-modal-thematique-btn-icon"
            />
            {thematiqueType.label}
          </button>
        ))}
      </div>
    </Modal>
  );
};
AddBlocModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AddBlocModal;
